var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSeqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0833 21.5827H33.9167V33.916H21.5833V40.0827H33.9167V52.416H40.0833V40.0827H52.4167V33.916H40.0833V21.5827ZM37 6.16602C19.98 6.16602 6.16666 19.9794 6.16666 36.9994C6.16666 54.0194 19.98 67.8327 37 67.8327C54.02 67.8327 67.8333 54.0194 67.8333 36.9994C67.8333 19.9794 54.02 6.16602 37 6.16602ZM37 61.666C23.4025 61.666 12.3333 50.5969 12.3333 36.9994C12.3333 23.4018 23.4025 12.3327 37 12.3327C50.5975 12.3327 61.6667 23.4018 61.6667 36.9994C61.6667 50.5969 50.5975 61.666 37 61.666Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSeqIcon);
export default __webpack_public_path__ + "static/media/AddSeqIcon.2298a3f1fb7302ccfe349220d96180e0.svg";
export { ForwardRef as ReactComponent };